import React from 'react'
import { ImageGallery, ImageProps } from './ImageGallery'
import { ProposalSpaceFragment } from '../Proposal.generated-types'
import flatMap from 'array.prototype.flatmap'

export const SpaceImageGallery = (
  space: ProposalSpaceFragment
): JSX.Element | null => {
  // TODO: convert this to using the native/built-in flatMap when the TypeScript version is updated
  const imageSources = flatMap<
  ProposalSpaceFragment['spacePhotos'][number],
  ImageProps
  >(space.spacePhotos ?? [], (photo) =>
    photo.url ? [{ src: photo.url }] : []
  )

  return <ImageGallery images={imageSources} />
}
